module.exports = __webpack_public_path__ + "assets/img/blaustoise.aa9a4e9c.png";